import React, { useState, useEffect } from 'react';
import StudentForm from './StudentForm';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';

function App() {
  const [showStep, setShowStep] = useState(true);

  // เพิ่ม: Redirect ไปยัง HTTPS เมื่ออยู่ใน production mode
  useEffect(() => {
    // บังคับใช้ HTTPS ใน production environment
    if (process.env.NODE_ENV === 'production' && 
        window.location.protocol !== 'https:') {
      window.location.href = `https://${window.location.host}${window.location.pathname}`;
    }
  }, []);

  return (
    <div className="App">
      <main>
        <StudentForm />
      </main>

      {showStep && (
        <div className="step-modal-overlay">
          <div className="step-modal-content">
            <picture>
              <source media="(min-width: 768px)" srcSet={process.env.PUBLIC_URL + '/step2-Reduce.png'} />
              <img 
                src={process.env.PUBLIC_URL + '/step-Reduce.png'} 
                alt="ขั้นตอนการสมัคร" 
                className="step-modal-image"
              />
            </picture>
            <button 
              onClick={() => setShowStep(false)}
              className="submit-button step-modal-btn"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;